"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = ReactLoadableComponent;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _baseLazyComponent = _interopRequireDefault(require("./base-lazy-component"));
function ReactLoadableComponent(name, resolve, files) {
  if (files === void 0) {
    files = [];
  }
  return /*#__PURE__*/function (_BaseLazyComponent) {
    (0, _inheritsLoose2["default"])(LoadableComponent, _BaseLazyComponent);
    function LoadableComponent(props) {
      var _this;
      _this = _BaseLazyComponent.call(this, props, {
        component: name,
        files: files,
        resolve: resolve
      }) || this;
      _this.state = {
        component: null
      };
      return _this;
    }
    var _proto = LoadableComponent.prototype;
    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;
      this.resourceLoader.then(function () {
        if (_this2.resolvedData) {
          var component = _this2.resolvedData["default"] || _this2.resolvedData;
          if (component) {
            _this2.setState({
              component: component
            });
          }
        }
      });
    };
    _proto.render = function render() {
      var _suspensePayload$reso;
      if (this.state.error) {
        throw this.state.error;
      }
      var suspensePayload = this.getSuspensePayload();
      var Component = (suspensePayload == null || (_suspensePayload$reso = suspensePayload.resolvedData) == null ? void 0 : _suspensePayload$reso["default"]) || (suspensePayload == null ? void 0 : suspensePayload.resolvedData);
      return this.renderComponent(Component);
    };
    return LoadableComponent;
  }(_baseLazyComponent["default"]);
}